import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axiosClient from 'api/axiosClient';
import axios from 'axios';
import { Col } from 'reactstrap'
import { useIntl } from 'react-intl';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { OLD_API_URL, IMAGE_BASE_URL, SETTING_IMAGE_URL } from 'utils/constants';

const CustomPrevArrow = (props) => {
    const { onClick } = props;
    return (
        <div
            onClick={onClick}
            style={{
                position: 'absolute',
                left: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 10,
                cursor: 'pointer',
                backgroundColor: '#fff',
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                transition: 'all 0.3s'
            }}
            className="custom-media-arrow"
        >
            <div style={{
                width: '8px',
                height: '8px',
                borderTop: '2.5px solid var(--primary-color)',
                borderLeft: '2.5px solid var(--primary-color)',
                transform: 'rotate(-45deg)',
                marginLeft: '3px'
            }}></div>
        </div>
    );
};

const CustomNextArrow = (props) => {
    const { onClick } = props;
    return (
        <div
            onClick={onClick}
            style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 10,
                cursor: 'pointer',
                backgroundColor: '#fff',
                width: '32px',
                height: '32px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                transition: 'all 0.3s'
            }}
            className="custom-media-arrow"
        >
            <div style={{
                width: '8px',
                height: '8px',
                borderTop: '2.5px solid var(--primary-color)',
                borderRight: '2.5px solid var(--primary-color)',
                transform: 'rotate(45deg)',
                marginRight: '3px'
            }}></div>
        </div>
    );
};

export default function MediaLQDTU(props) {
    const intl = useIntl();
    const info = props.info;
    const [images, setImages] = useState([]);

    const getBgColor = (imgtil) => {
        if (imgtil === 'BRANDING') return '#80A618';
        if (imgtil === 'IMAGE') return 'var(--primary-color)';
        if (imgtil === 'VIDEO') return '#A60404';
        return '#1E96F7'; // BULLETIN
    };

    useEffect(() => {
        if (info.imgtil === 'IMAGE') {
            axios.get(`${OLD_API_URL}/image/album/5`).then(res => {
                if (res.data && res.data.rows) {
                    setImages(res.data.rows);
                }
            }).catch(err => console.error(`Error fetching images for ${info.imgtil} slider:`, err));
        } else if (info.imgtil === 'BRANDING') {
            axiosClient.get(`/brand_identity?highlight=1`).then(res => {
                if (res.data) {
                    setImages(res.data);
                }
            }).catch(err => console.error(`Error fetching images for ${info.imgtil} slider:`, err));
        }
    }, [info.imgtil]);

    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />,
        fade: false,
        pauseOnHover: true
    };

    const renderIconContent = () => {
        if ((info.imgtil === 'IMAGE' || info.imgtil === 'BRANDING') && images.length > 0) {
            const displayImages = info.imgtil === 'BRANDING' ? [...images].reverse() : images;
            return (
                <div className="media-slider-container" style={{ width: '100%', height: '100%', position: 'relative' }}>
                    <Slider {...settings}>
                        {displayImages.map((img, index) => (
                            <div key={index} style={{ width: '100%', height: '100%' }}>
                                <img
                                    src={info.imgtil === 'BRANDING' ? `${SETTING_IMAGE_URL}/${img.file_preview}` : `${IMAGE_BASE_URL}/${img.url}`}
                                    alt={`slide-${index}`}
                                    style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover'
                                    }}
                                />
                            </div>
                        ))}
                    </Slider>
                </div>
            );
        }
        return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <img src={info.image} className="img-media" alt={info.title} style={{ height: '80px', width: 'auto', objectFit: 'contain' }} />
                <p style={{ fontSize: '14px', color: '#FFFFFF', fontWeight: '700', marginTop: '10px', marginBottom: 0 }}>{info.imgtil}</p>
            </div>
        );
    };

    return (
        <Col md="4" sm="12" className="mb-4">
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                <div
                    className={`media-icon-circle ${info.imgtil} ${(info.imgtil === 'IMAGE' || info.imgtil === 'BRANDING') ? 'has-slider' : ''}`}
                    style={{
                        backgroundColor: getBgColor(info.imgtil),
                        borderRadius: '8px',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: '25px',
                        boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                        overflow: 'hidden',
                        position: 'relative'
                    }}
                >
                    {info.title === "Video" ? (
                        <a href={info.linkSrc} target="_blank" rel="noopener noreferrer" style={{ display: 'block', width: '100%', height: '100%' }}>
                            {renderIconContent()}
                        </a>
                    ) : (
                        <Link to={info.linkSrc} style={{ display: 'block', width: '100%', height: '100%' }}>
                            {renderIconContent()}
                        </Link>
                    )}
                </div>
                <div className="me-info" style={{ width: '100%', minHeight: '150px' }}>
                    <p className="me-info-1" style={{ color: 'var(--primary-color)', fontWeight: '700', fontSize: '22px', marginBottom: '0.8em', lineHeight: '1.4' }}>
                        {info.title === "Video" ? (
                            <a href={info.linkSrc} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary-color)', fontWeight: '700', fontSize: '22px' }}>{info.title}</a>
                        ) : (
                            <Link to={info.linkSrc} style={{ color: 'var(--primary-color)', fontWeight: '700', fontSize: '22px' }}>{info.title}</Link>
                        )}
                    </p>
                    <p style={{ color: '#161616', fontSize: '16px', fontWeight: '500', marginBottom: '1em', lineHeight: '1.6' }}>{info.content}</p>
                    {info.title === "Video" ? (
                        <a href={info.linkSrc} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary-color)', fontSize: '16px', fontWeight: '700', textDecorationLine: 'underline' }}>{intl.formatMessage({ id: 'Read More' })}</a>
                    ) : (
                        <Link to={info.linkSrc} style={{ color: 'var(--primary-color)', fontSize: '16px', fontWeight: '700', textDecorationLine: 'underline' }}>{intl.formatMessage({ id: 'Read More' })}</Link>
                    )}
                </div>
            </div>
        </Col>
    );
}